export default "__VITE_ASSET__Cj5TW85$__"